import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter as Router } from "react-router-dom";
// AntD v5 compatibility shim for React 19. Without this, `Modal` /
// `Modal.confirm` / `notification` / `message` static calls fail to render
// silently on React 19 because antd v5 was authored against React 16–18's
// rendering semantics. Import once at the app root before any AntD call
// sites mount.
import "@ant-design/v5-patch-for-react-19";

import "./index.css";
import { Bounce, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthProvider } from "./context/AuthContext";
import { OrgUsersProvider } from "./context/OrgUsersContext";
import { TutorialProvider } from "./context/TutorialContext";
import { GstFetchTrackerProvider } from "./context/GstFetchTrackerContext";
import { TutorialTour } from "./components/Tutorial/TutorialTour";
import { TutorialFloatButton } from "./components/Tutorial/TutorialFloatButton";
import { WelcomeModal } from "./components/Tutorial/WelcomeModal";

// ResizeObserver benign-warning suppression (development only).
//
// Browsers emit "ResizeObserver loop completed with undelivered notifications"
// when an observer cannot deliver every callback inside one animation frame.
// It is a timing notice, not a fault: nothing is broken and no render is lost.
// AntD components that observe their own size (Modal, Progress, Table, Select)
// trigger it routinely.
//
// The problem is only that Create React App's dev overlay treats ANY window
// error as fatal and covers the whole screen with it, which makes the app look
// broken and blocks testing. Production builds have no overlay and are
// unaffected.
//
// This matches that ONE exact message and nothing else, so genuine runtime
// errors still reach the overlay untouched. Deliberately narrow: a blanket
// error swallow here would hide real bugs.
if (process.env.NODE_ENV === "development") {
  const RESIZE_OBSERVER_NOISE = [
    "ResizeObserver loop completed with undelivered notifications",
    "ResizeObserver loop limit exceeded",
  ];
  const isResizeObserverNoise = (text) =>
    typeof text === "string" &&
    RESIZE_OBSERVER_NOISE.some((msg) => text.includes(msg));

  window.addEventListener("error", (event) => {
    if (isResizeObserverNoise(event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <AuthProvider>
      <OrgUsersProvider>
        <TutorialProvider>
          <GstFetchTrackerProvider>
          <App />
          {/* <TutorialTour />
          <TutorialFloatButton /> */}

          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
            transition={Bounce}
          />
          </GstFetchTrackerProvider>
        </TutorialProvider>
      </OrgUsersProvider>
    </AuthProvider>
  </Router>
);
